import { ViewModel,View, ObservableArray } from "binder"
import { SearchRecursive } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import  { AccountSelectorView } from "./accountSelector-view"

export class AccountSelectorViewModel extends ViewModel implements IAccountLoadingObserver{
    
    constructor(parentViewModel: ViewModel,loader?:IAccountLoader)
    {
        super(parentViewModel);
        if(loader==null){
            loader = new AccountLoader();
        }
        this.isLoaded = false;
        this.accounts = ObservableArray.create<singleAccount>();
        this._accountLoader = loader;
        this._accountLoader.attach(this);
        this.refresh();
        this.isShowingPopup = true;
    }
    GetDefaultView(): View <ViewModel> {
        return new AccountSelectorView();
    }
    public getTypeId(): string {
        return "VM-25274383-E16E-467C-85ED-B130C2FA0598"
    }

    selectAccount(singleAccount: singleAccount) {
        this.selectedAccount = singleAccount;
        this.isShowingPopup = false;
    }
    
    public set accounts(v: ObservableArray<singleAccount>) { this._accounts = v; } public get accounts(): ObservableArray<singleAccount> { return this._accounts;} private _accounts: ObservableArray<singleAccount>;
    public set selectedAccount(v: singleAccount) { 
        let isSame = this._selectedAccount?.id==v?.id;
        this._selectedAccount = v; 
        this.selectedId = v?.id;
        if(v){
            let names = [];
            let current = v;
            while(current!=null){
                names.unshift(current);
                current=current.parentAccount;
            }
            this.selectedAccountName = names.map(q=>q.title).join(' | ');
        }else{
            this.selectedAccountName = '';
        }
        if(isSame==false)
            this.onSelectionChanged(v);
    } public get selectedAccount(): singleAccount { return this._selectedAccount;} private _selectedAccount: singleAccount;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set selectedAccountName(v: string) { this._selectedAccountName = v; } public get selectedAccountName(): string { return this._selectedAccountName;} private _selectedAccountName: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    
    private selectedId:string;
    private _accountLoader : IAccountLoader;
    private isLoaded:boolean;
    async refresh(){
        try {
            this.isLoading = true;
            let result =await this.loadData();
            this.isLoaded = true;
            this.accounts.update(...result);
            if(this.selectedId!=null){
                this.selectById(this.selectedId);                
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    requestRefresh(){
        this._accountLoader.refresh();
    }
    public selectById(id:string){
        if(id==null){
            this.selectedId = null;
            this.selectedAccount = null;
        }else{
            this.selectedId = id;
            if(this.isLoaded==false)return;
            let filteredItem = SearchRecursive(this.accounts,q=>q.children,x=>x.id==id);
            this.selectedAccount = filteredItem;
        }
    }

    update(accounts: singleAccount[]) {
        this.accounts.update(...accounts);
        this.isLoaded = true;
        this.selectById(this.selectedId);
    }

    protected async loadData():Promise<singleAccount[]>{
        try {
            this.isLoading = true;
            let result = await this._accountLoader.getAccounts(this);
            return result;
        } catch (ex) {
            console.log(ex);
            return [];
        } finally {
            this.isLoading = false;
        }
    } 

    onSelectionChanged(element:singleAccount){};

}

export class singleAccount extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.details = ObservableArray.create<singleDetail>();
        this.children = ObservableArray.create<singleAccount>();
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set isSelectable(v: boolean) { this._isSelectable = v; } public get isSelectable(): boolean { return this._isSelectable;} private _isSelectable: boolean;
    public set children(v: ObservableArray<singleAccount>) { this._children = v; } public get children(): ObservableArray<singleAccount> { return this._children;} private _children: ObservableArray<singleAccount>;
    public set parentAccount(v: singleAccount) { this._parentAccount = v; } public get parentAccount(): singleAccount { return this._parentAccount;} private _parentAccount: singleAccount;
    public set details(v: ObservableArray<singleDetail>) { this._details = v; } public get details(): ObservableArray<singleDetail> { return this._details;} private _details: ObservableArray<singleDetail>;
    
    select(){
        if(this.isSelectable){
            this.selectAccount(this);
        }
    }
    selectAccount(singleAccount:singleAccount){
        if(this.parentAccount){
            this.parentAccount.selectAccount(singleAccount);
        }else{
            (<AccountSelectorViewModel>this.parentViewModel).selectAccount(singleAccount);
        }
    }
}

export class singleDetail extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set assignmentId(v: string) { this._assignmentId = v; } public get assignmentId(): string { return this._assignmentId;} private _assignmentId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set typeName(v: string) { this._typeName = v; } public get typeName(): string { return this._typeName;} private _typeName: string;
}
export interface IAccountLoadingObserver{
    update(accounts:singleAccount[]);
}
export abstract class IAccountLoader{
    constructor() {
        this.observers = [];        
    }
    public abstract getAccounts(requester:IAccountLoadingObserver):Promise<singleAccount[]>;
    public abstract refresh();
    private observers:WeakRef<IAccountLoadingObserver>[];

    attach(observer:IAccountLoadingObserver){
        let wr = new WeakRef<IAccountLoadingObserver>(observer);
        this.observers.push(wr);
    }
    detach(observer:IAccountLoadingObserver){
        let index = this.observers.findIndex(x=>x.deref()==observer);
        if(index>-1){
            this.observers.splice(index)
        }
    }
    notify(except:IAccountLoadingObserver[],dtoResult:any){
        for(let i=this.observers.length-1;i>=0;i--){
            let x = this.observers[i].deref();
            if(x==null){
                this.observers.splice(i,1);
            }else{
                if(except.includes(x)==false){
                    let parsedResult = new AccountParser().Parse(dtoResult,<ViewModel><unknown>x);
                    x.update(parsedResult);
                }
            }
        }
    }
}
class AccountParser{
    public Parse(dto:any,parent:ViewModel):singleAccount[]{
        return dto.Accounts.map(x=>this.parseSingle(x,parent,null));
    }

    private parseSingle(dto:any,parent:ViewModel,parentAccount:singleAccount):singleAccount{
        let result = new singleAccount(parent);
        result.id = dto.Id;
        result.name = dto.Name;
        result.code = dto.Code;
        result.title = `${dto.Name} (${dto.Code})`;
        result.parentAccount = parentAccount;
        result.details.update(...dto.DistinguishingDetails.map(q=>{
            let r = new singleDetail(result);
            r.id = q.Id;
            r.name = q.AssignmentName;
            r.typeName = q.Name;
            r.assignmentId = q.AssignmentId;
            return r;
        }))
        result.children.update(...dto.ChildAccounts.map(x=>this.parseSingle(x,result,result)));
        result.isSelectable = result.children.length==0 ? true : false;
        return result;
    }
}
export class AccountLoader extends IAccountLoader{
    override async getAccounts(requester:IAccountLoadingObserver):Promise<singleAccount[]> {
        let dtoResult = await ServerConnection.callServer('Complex/AccountingServices/GetAllAccounts',{});
        if(dtoResult.IsSuccessful){
            if(requester==null){
                this.notify([],dtoResult);
                return [];
            }
            if(requester!=null){
                let parsedResult = new AccountParser().Parse(dtoResult,<ViewModel><unknown>requester);
                this.notify([requester],dtoResult);
                return parsedResult;
            }
        }
        throw "Exception Loading Accounts";
    }
    public override refresh() {
        this.getAccounts(null);
    }
}

export class CachedAccountLoader extends IAccountLoader{
    private lastResult :any;
    private isExecuting:boolean;
    override async getAccounts(requester:IAccountLoadingObserver):Promise<singleAccount[]> {
        if(this.lastResult!=null){
            let parsedResult = new AccountParser().Parse(this.lastResult,<ViewModel><unknown>requester);
            return parsedResult;
        }
        if(this.isExecuting==true)
            return [];
        try{
            this.isExecuting = true;
            let dtoResult = await ServerConnection.callServer('Complex/AccountingServices/GetAllAccounts',{});
            if(dtoResult.IsSuccessful){
                this.lastResult = dtoResult;
                if(requester==null){
                    this.notify([],dtoResult);
                    return [];
                }
                if(requester!=null){
                    let parsedResult = new AccountParser().Parse(dtoResult,<ViewModel><unknown>requester);
                    this.notify([requester],dtoResult);
                    return parsedResult;
                }
            }
            throw "Exception Loading Accounts";
        }finally{
            this.isExecuting = false;
        }
        
    }
    public override refresh() {
        this.lastResult = null;
        this.getAccounts(null);
    }
}